import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PosSupplierService {


  url = environment.serverAPI5 + "/api/supplier"; 
  
  constructor(private http: HttpClient) { }

  getAllSupplier(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllsupplierDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getSupplierById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditSupplier(supplier: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, supplier);
  }

  SupplierSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteImage(data: any): Observable<Object> {
		return this.http.post(`${this.url}/deleteImage`, data);
	}
  deleteBySupplierModelId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/${id}`);
	}
  downloadSupplierTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, {responseType: 'arraybuffer',observe: 'response' });
  }
  downloadSupplierReport(Page: number, size: number, sort,selectionBrands): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionBrands, { 
      responseType: 'arraybuffer',
      observe: 'response'
    });
  } 
}
